module.exports = __webpack_public_path__ + "img/icon-reg-search-ticket.2eaa5cab.png";